import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ContentSection } from '../components/ContentSection';
import { BonusSection } from '../components/BonusSection';
import { AudienceSection } from '../components/AudienceSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { UpsellSection } from '../components/UpsellSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-rose-200 selection:text-rose-900" data-id="element-361">
      <main data-id="element-362">
        <HeroSection data-id="element-363" />
        <ProblemSection data-id="element-364" />
        <SolutionSection data-id="element-365" />
        <ContentSection data-id="element-366" />
        <BonusSection data-id="element-367" />
        <AudienceSection data-id="element-368" />
        <TestimonialsSection data-id="element-369" />
        <UpsellSection data-id="element-370" />
        <PricingSection data-id="element-371" />
        <FAQSection data-id="element-372" />
        <FinalCTASection data-id="element-373" />
      </main>
      <Footer data-id="element-374" />
    </div>;
}